<template>
    <div v-if="project != null">
        <el-dialog :visible="visible" :modal-append-to-body="true" :class="['project-detail-dialog', 'ah-detail-dialog']" top="5vh" append-to-body :before-close="handleBeforeClose" ref="DetailDialog">
            <template slot="title">
                <el-row>
                    <el-col :span="16">
                        專案 <span class="sno"># {{ project.poo }}</span>
                    </el-col>
                    <el-col :span="8">
                        <!-- <el-button size="small">列印</el-button> -->
                    </el-col>
                </el-row>
            </template>
            <div class="detail-row header" style="padding-bottom: 20px">
                <el-row :gutter="40">
                    <el-col :sm="24">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div class="detail-block">
                                <div style="margin: 15px 0 0 0">
                                    <div style="font-size: 10.5pt; margin-bottom: 5px; color: #574fba">
                                        <div>{{ project.pjcaT_NAM }}</div>
                                    </div>
                                    <div style="font-size: 15pt; font-weight: bold; margin-top: 5px">
                                        <div>{{ project.nam }}</div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <el-dropdown @command="onMoreDropdownClick">
                                    <el-button size="mini">
                                        <i class="el-icon-more"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="duplicate" icon="el-icon-document-copy">複製專案</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="detail-row" style="margin-bottom: 20px">
                <div class="detail-block">
                    <el-row :gutter="40">
                        <el-col :sm="14">
                            <table class="ah-basic-data-table">
                                <tbody>
                                    <tr>
                                        <th>狀態</th>
                                        <td>
                                            <span v-if="project.stG_STS === 1" class="ah-status done">結案</span>
                                            <span v-if="project.stG_STS === 0" class="ah-status pending">進行中</span>
                                        </td>
                                    </tr>
                                    <tr v-if="project.customnumber">
                                        <th>自訂專案編號</th>
                                        <td>{{ project.customnumber }}</td>
                                    </tr>
                                    <tr>
                                        <th>專案經理</th>
                                        <td>{{ project.stF_SNO_NAM }}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>專案經辦人</span>
                                            <ah-tip icon="el-icon-warning-outline" codlor="#ffa230" v-if="!isProjectAuditorAuditNeed">當前專案審核流程未啟用專案經辦人，此項目無作用。</ah-tip>
                                        </th>
                                        <td>
                                            <div v-if="project.projectAuditorName">
                                                <span style="margin-right: 10px">{{ project.projectAuditorName }}</span>
                                                <el-tooltip effect="light" content="專案經辦人可以從「請款單」檢視此專案細節。" placement="top-start" v-if="project.isProjectDetailsVisible">
                                                    <el-tag type="info" size="small" style="margin-right: 5px"><i class="el-icon-view"></i> 細節</el-tag>
                                                </el-tooltip>
                                                <el-tooltip effect="light" content="專案經辦人可以從「請款單」看見此專案的支出預算圖表。" placement="top-start" v-if="project.isProjectBudgetVisible">
                                                    <el-tag type="info" size="small" style="margin-right: 5px"><i class="el-icon-view"></i> 預算</el-tag>
                                                </el-tooltip>
                                            </div>
                                            <div v-else>(無)</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>客戶</th>
                                        <td>
                                            <span v-if="vendor">{{ vendor.fnam }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>專案開始日期</th>
                                        <td>
                                            <span v-if="project.sdt">{{ project.sdt | dateFormater("YYYY-MM-dd") }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>預計結束日期</th>
                                        <td>
                                            <span v-if="project.edt">{{ project.edt | dateFormater("YYYY-MM-dd") }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>成案依據</th>
                                        <td>
                                            <el-tag v-if="isContractExist" type="info" size="small" style="margin-right: 5px"> <i class="el-icon-check"></i> 合約 </el-tag>
                                            <el-tag v-if="isQuotationExist" type="info" size="small" style="margin-right: 5px"> <i class="el-icon-check"></i> 報價單 </el-tag>
                                            <el-tag v-if="isOtherContractFileExist" type="info" size="small"> <i class="el-icon-check"></i> 其他 </el-tag>
                                            <div>
                                                <a v-if="project.filE_QUOTATION" :href="project.filE_QUOTATION" class="el-button el-button--text">報價單下載</a>
                                                <a v-if="project.filE_CONTRACT" :href="project.filE_CONTRACT" class="el-button el-button--text">合約下載</a>
                                            </div>
                                            <div v-if="!isContractExist && !isQuotationExist && !isOtherContractFileExist" style="opacity: 0.4">(無)</div>
                                        </td>
                                    </tr>
                                    <tr style="display: none">
                                        <th>開放請款/發票/勞報單</th>
                                        <td>
                                            <el-tooltip class="item" effect="light" content="開放他人申請此專案的請款" placement="top-start" v-if="project.public_PAYOUT">
                                                <span>
                                                    <el-tag type="success" size="small" style="margin-right: 5px"><i class="el-icon-check"></i> 請款</el-tag>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="light" content="只能由「專案經理」申請此專案的請款" placement="top-start" v-if="!project.public_PAYOUT">
                                                <span>
                                                    <el-tag type="info" size="small" style="margin-right: 5px"><i class="el-icon-close"></i> 請款</el-tag>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="light" content="開放他人申請此專案的發票" placement="top-start" v-if="project.public_INVOICE">
                                                <span>
                                                    <el-tag type="success" size="small" style="margin-right: 5px"><i class="el-icon-check"></i> 發票</el-tag>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="light" content="只能由「專案經理」申請此專案的發票" placement="top-start" v-if="!project.public_INVOICE">
                                                <span>
                                                    <el-tag type="info" size="small" style="margin-right: 5px"><i class="el-icon-close"></i> 發票</el-tag>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="light" content="開放他人建立此專案的勞報單" placement="top-start" v-if="project.isServiceFeeStatement">
                                                <span>
                                                    <el-tag type="success" size="small"><i class="el-icon-check"></i> 勞報單</el-tag>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip
                                                class="item"
                                                effect="light"
                                                content="只能由此「專案經理」、「專案經辦人」建立此專案的勞報單"
                                                placement="top-start"
                                                v-if="!project.isServiceFeeStatement"
                                            >
                                                <span>
                                                    <el-tag type="info" size="small"><i class="el-icon-close"></i> 勞報單</el-tag>
                                                </span>
                                            </el-tooltip>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>備註</th>
                                        <td>
                                            <div v-if="project.note != null && project.note != ''" style="white-space: pre-line">
                                                {{ project.note }}
                                            </div>
                                            <div v-else style="opacity: 0.4">(無)</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-col>
                        <el-col :sm="10">
                            <table class="ah-basic-data-table">
                                <tbody>
                                    <tr class="strong">
                                        <th>專案總價（含稅）</th>
                                        <td>
                                            <div style="font-size: 18pt">
                                                <Money :v="project.amt" :precision="project.cny === 'TWD' ? null : 4" />
                                                <span class="cny" style="font-size: 12pt">
                                                    {{ project.cny }}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>支出預算（台幣）</th>
                                        <td>
                                            <Money :v="project.amT_PREOUT" />
                                            <span v-if="false" class="cny" style="font-size: 9pt; font-weight: normal; opacity: 0.4">TWD</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            已支出金額（台幣）
                                            <ahTip>
                                                <PaymentStatusLabel :statusNum="2" />
                                                ＋
                                                <PaymentStatusLabel :statusNum="3" /> 的請款總額
                                            </ahTip>
                                        </th>
                                        <td>
                                            <Money :v="payoutTotal" round />
                                            <span v-if="false" class="cny" style="font-size: 9pt; font-weight: normal; opacity: 0.4">TWD</span>
                                        </td>
                                    </tr>

                                    <tr v-if="installmentsDiscountTotal" class="strong">
                                        <th>專案折讓總額（含稅）</th>
                                        <td>
                                            <div style="color: red">
                                                <Money :v="installmentsDiscountTotal" />
                                                <span class="cny">
                                                    {{ project.cny }}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="strong" v-if="project.cny != 'TWD'" style="opacity: 0.4">
                                        <th>
                                            專案總價（約當台幣）<ahTip>當前匯率：{{ currCnyRatio }}</ahTip>
                                        </th>
                                        <td>
                                            <div style="font-size: 10pt">
                                                <Money :v="amtTWD" />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>預估毛利率<ahTip>((專案總價 - 已折讓發票總額) - 專案預算) / (專案總價 - 已折讓發票總額)</ahTip></th>
                                        <td>{{ estimateGrossMargin }} %</td>
                                    </tr>
                                    <tr v-if="false">
                                        <th>預估毛利</th>
                                        <td>
                                            <Money :v="estimateGrossProfit" v-if="estimateGrossProfit" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>實際毛利<ahTip>((專案總價 - 已折讓發票總額) - 已支出金額)</ahTip></th>
                                        <td>
                                            <Money :v="actualGrossProfit" v-if="actualGrossProfit" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>實際毛利率<ahTip>((專案總價 - 已折讓發票總額) - 已支出金額) / (專案總價 - 已折讓發票總額)</ahTip></th>
                                        <td>{{ actualGrossMargin }} %</td>
                                    </tr>
                                </tbody>
                            </table>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- Tabs -->
            <el-tabs class="detail-tabs" v-model="currTab">
                <el-tab-pane label="分期款項" name="installments"> </el-tab-pane>
                <el-tab-pane name="payouts">
                    <template slot="label">
                        支出列表<span v-if="project && project.payouts">({{ project.payouts.length }})</span>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="service-fee-statement" v-if="isPayed('H01')">
                    <template slot="label">
                        勞報單<span v-if="project && project.serviceFeeStatement">({{ project.serviceFeeStatement.length }})</span>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="member">
                    <template slot="label">
                        專案成員<span v-if="project && project.staffs">({{ project.staffs.length }})</span>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="contract">
                    <template slot="label">
                        合約與文件<span v-if="project && project.contractFiles">({{ project.contractFiles.length }})</span>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="history" v-if="project.modifyLogs && project.modifyLogs.length > 0">
                    <template slot="label">
                        編輯紀錄<span v-if="project && project.modifyLogs">({{ project.modifyLogs.length }})</span>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="voidInstallments" v-if="project.voidInvoices && project.voidInvoices.length > 0">
                    <template slot="label"> 作廢發票({{ project.voidInvoices.length }}) </template>
                </el-tab-pane>
            </el-tabs>
            <div class="detail-row" v-if="currTab == 'installments'">
                <div class="detail-block">
                    <div class="installment-list">
                        <el-table class="ah-el-data-table" :data="project.installments" empty-text="沒有分期項目" :key="'installments'">
                            <el-table-column type="index" width="45"> </el-table-column>
                            <el-table-column prop="stG_NO" label="分期" width="110">
                                <template slot-scope="scope">
                                    <div
                                        :style="{
                                            opacity: scope.row.status == 5 ? '0.2' : '1',
                                        }"
                                    >
                                        第 {{ scope.row.stG_NO }} 期款
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sts" label="發票狀態" width="110">
                                <template slot-scope="scope">
                                    <InvoiceStatusLabel v-if="scope.row.invoiceNo" :status-num="scope.row.status" size="small" />
                                    <div v-else style="opacity: 0.5; font-size: 9pt">(未開)</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="發票單號" width="150">
                                <template slot-scope="scope">
                                    <div class="idx" style="text-decoration: underline; cursor: pointer" @click="handleInvoiceClick(scope.row.invoiceNo)">
                                        {{ scope.row.invoiceIOO }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="發票號碼">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.status === 2 || scope.row.status === 3">
                                        <div>
                                            <ahReceiptNumber :v="scope.row.invoiceFOO" />
                                            <span v-if="scope.row.foO_DIS_CNL" class="discount-block">發票已作廢</span>
                                        </div>
                                        <div v-if="vendor.fnam !== scope.row.buyerName" class="other-buyer">買受人：{{ scope.row.buyerName }}</div>
                                        <div class="foo-dat">
                                            <span v-if="isFutureInvoiceDate(scope.row.foO_DAT)" class="is-future"> 預開：{{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }} </span>
                                            <span v-else>
                                                {{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}
                                            </span>
                                        </div>
                                        <div v-if="!scope.row.foO_DIS_CNL && scope.row.foO_DIS_AMT" class="discount-amt">
                                            <div>折讓：<Money :v="scope.row.foO_DIS_AMT" /></div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="amt" label="金額" align="right">
                                <template slot-scope="scope">
                                    <div
                                        :style="{
                                            opacity: scope.row.status == 5 ? '0.2' : '1',
                                        }"
                                    >
                                        <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="cny" label="幣別" width="100"></el-table-column>
                        </el-table>
                    </div>
                    <div class="total-amount" style="padding-bottom: 30px">
                        <span class="label">分期總計：</span>
                        <span class="value"> <Money :v="installmentsSum" :precision="project.cny === 'TWD' ? null : 4" /> </span>
                        <span class="cny">{{ project.cny }}</span>
                    </div>
                </div>
            </div>
            <div class="detail-row" v-if="currTab == 'voidInstallments'">
                <div class="detail-block">
                    <div class="installment-list">
                        <el-table class="ah-el-data-table" :data="project.voidInvoices" empty-text="沒有作廢發票" :key="'voidInstallments'">
                            <el-table-column type="index" width="45"> </el-table-column>
                            <el-table-column prop="sts" label="發票狀態" width="110">
                                <template slot-scope="scope">
                                    <InvoiceStatusLabel v-if="scope.row.invoiceNo" :status-num="scope.row.status" size="small" />
                                    <div v-else style="opacity: 0.5; font-size: 9pt">(未開)</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="發票單號" width="150">
                                <template slot-scope="scope">
                                    <div class="idx" style="text-decoration: underline; cursor: pointer" @click="handleInvoiceClick(scope.row.invoiceNo)">
                                        {{ scope.row.invoiceIOO }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="發票號碼">
                                <template slot-scope="scope">
                                    {{ scope.row.invoiceFOO }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="amt" label="金額" align="right">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="cny" label="幣別" width="100"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div class="detail-row" v-if="currTab == 'payouts'">
                <div class="detail-block">
                    <div class="tab-content-header" style="position: relative; top: -15px">
                        <div></div>
                        <div style="display: flex; align-items: center; gap: 10px">
                            <el-button size="mini" icon="el-icon-download" @click="onExportPayoutExcel" :disabled="!project.payouts || project.payouts.length === 0">匯出 Excel</el-button>
                            <el-radio-group v-model="payoutTab" size="mini">
                                <el-radio-button label="list">明細</el-radio-button>
                                <el-radio-button label="summary">統計</el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="payment-list" v-if="payoutTab === 'list'">
                        <el-table class="ah-el-data-table" :data="project.payouts" empty-text="沒有支出項目" size="small" :key="'payments'">
                            <el-table-column type="index" width="45"> </el-table-column>
                            <el-table-column prop="paY_STS" label="請款狀態" width="106">
                                <template slot-scope="scope">
                                    <PaymentStatusLabel :statusNum="scope.row.sigN_STS" size="small" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="paY_STS" label="請款單號" width="110">
                                <template slot-scope="scope">
                                    <div class="idx" style="text-decoration: underline; cursor: pointer" @click="handlePaymentClick(scope.row.sno)">{{ scope.row.payoo }}</div>
                                    <div v-if="scope.row.tranServiceFeeStatement">[勞務單轉送]</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nam" label="請款摘要"> </el-table-column>
                            <el-table-column prop="iteM_NAM" label="支出項目" width="145">
                                <template slot-scope="scope">
                                    <span class="payout-item-label">{{ scope.row.iteM_NAM }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="實際付款日" width="120">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.sigN_STS === 2 || scope.row.sigN_STS === 3">{{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}</span>
                                    <span v-else style="opacity: 0.4">---</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="amt" label="金額" align="right" width="110">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                                    <ahTip v-if="scope.row.cny != 'TWD'">
                                        <div>
                                            約當台幣：
                                            <Money :v="scope.row.paY_CNYRAT != 1 ? scope.row.amt * scope.row.paY_CNYRAT : scope.row.amt * getCnyRat(scope.row.cny)" round />
                                        </div>
                                        <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">
                                            匯率：{{ scope.row.paY_CNYRAT != 1 ? scope.row.paY_CNYRAT : getCnyRat(scope.row.cny) + " (即時)" }}
                                        </div>
                                    </ahTip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="cny" label="幣別" width="70"></el-table-column>
                        </el-table>
                        <div class="total-amount" v-if="payoutTotal > 0">
                            <span class="label">
                                <ahTip>
                                    <PaymentStatusLabel :statusNum="2" />
                                    ＋
                                    <PaymentStatusLabel :statusNum="3" />
                                    的請款總額
                                </ahTip>
                                <span> 專案總支出：</span>
                            </span>
                            <span class="value"> <Money :v="payoutTotal" /></span>
                            <span class="cny">TWD</span>
                        </div>
                    </div>
                    <div v-if="payoutTab === 'summary'">
                        <ProjectPayoutSummary :payouts="project.payouts" />
                    </div>
                </div>
            </div>
            <ProjectDetailContractTab v-if="currTab == 'contract'" :value="project.contractFiles" :project="project" :sno="sno" @refresh="loadData(sno)" />
            <div class="total-amount" v-if="false && project.amT_PREOUT > 0">
                <span class="label">佔預算支出%：</span>
                <span class="value">{{ Math.round((payoutTotal / project.amT_PREOUT) * 100) }}% </span>
                <span class="cny"></span>
            </div>
            <div class="spacing"></div>
            <ProjectDetailHistoryTab v-if="currTab == 'history' && project.modifyLogs && project.modifyLogs.length > 0" :data="project.modifyLogs" />
            <ProjectDetailMemberTab v-if="currTab == 'member'" :members="project.projectEmployeePermissions" />
            <div v-if="currTab == 'service-fee-statement'" class="detail-row">
                <div class="detail-block">
                    <ServiceFeeStatementDetailView :service-fee-statement-list="project.serviceFeeStatement" no-header isShowEmptyTable />
                </div>
            </div>
            <div class="detail-row footer">
                <div style="display: flex; justify-content: space-between">
                    <div>
                        <el-button type="" @click="handleBeforeClose"> 返回列表 </el-button>
                    </div>
                    <div v-if="isAuth('C04') || (isAuth('C01') && isCreator)">
                        <el-tooltip :manual="isShowDeleteBtn" class="item" effect="dark" content="此專案已有申請請款單／發票資料，無法刪除" placement="top">
                            <span style="margin-right: 10px">
                                <el-button type="danger" :disabled="!isShowDeleteBtn" @click="onDeleteProject"> 刪除專案 </el-button>
                            </span>
                        </el-tooltip>
                        <el-button
                            @click="
                                $router.push({
                                    name: 'project-edit',
                                    params: { sno: project.sno },
                                })
                            "
                            >編輯</el-button
                        >
                    </div>
                </div>
            </div>
        </el-dialog>
        <PaymentDetailDialog @close="handlePaymentDetailDialogClose" :visible="paymentDetailDialog.visible" :sno="paymentDetailDialog.sno" />
        <InvoiceDetailDialog @close="handleInvoiceDetailDialogClose" :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import ExcelJS from 'exceljs';
import ahTip from '@/components/ui/ahTip.vue';
import PaymentDetailDialog from '@/components/dashboard/Payment/PaymentDetailDialog.vue';
import InvoiceDetailDialog from '@/components/dashboard/Invoice/InvoiceDetailDialog.vue';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import { paymentStatus } from '@/assets/commonData/options';
import { dateFormater } from '@/filters/index';
import InvoiceStatusLabel from '@/components/dashboard/Invoice/InvoiceStatusLabel.vue';
import ProjectDetailContractTab from '@/components/dashboard/Project/ProjectDetailContractTab.vue';
import ProjectDetailHistoryTab from '@/components/dashboard/Project/ProjectDetailHistoryTab.vue';
import ProjectDetailMemberTab from '@/components/dashboard/Project/ProjectDetailMemberTab.vue';
import ServiceFeeStatementDetailView from '@/components/dashboard/Project/ServiceFeeStatementDetailView.vue';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';
import ProjectPayoutSummary from './components/ProjectPayoutSummary.vue';

export default {
    name: 'ProjectDetailDialog',
    props: ['close', 'sno', 'visible'],
    components: {
        ahTip,
        PaymentDetailDialog,
        InvoiceDetailDialog,
        PaymentStatusLabel,
        InvoiceStatusLabel,
        ProjectDetailContractTab,
        ProjectDetailHistoryTab,
        ProjectDetailMemberTab,
        ServiceFeeStatementDetailView,
        ahReceiptNumber,
        ProjectPayoutSummary,
    },
    data() {
        return {
            isLoading: false,
            project: {}, // import values in loadData
            currTab: 'installments',
            payoutTab: 'list', // list, summary
            modifyLogActiveItem: null,
            cnyList: [],
            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
            paymentDetailDialog: {
                visible: false,
                sno: null,
            },
            vendor: null,
            isAuditFlowSettingEnable: {
                isEnable: false,
                settings: [],
            },
        };
    },
    watch: {
        sno(newSno) {
            if (newSno) this.loadData(newSno);
            else this.resetData();
        },
    },
    async mounted() {
        await this.fetchAuditFlow();
        this.resetData();
    },
    computed: {
        isProjectAuditorAuditNeed() {
            if (!this.isAuditFlowSettingEnable.isEnable) return false;

            let PROJECT_AUDITOR_FOUND = _.chain(this.isAuditFlowSettingEnable.settings).flatMap('steps').find(['menU_UNT', '專案經辦人']).value();

            if (!PROJECT_AUDITOR_FOUND) {
                PROJECT_AUDITOR_FOUND = _.chain(this.isAuditFlowSettingEnable.settings).flatMap('steps').find(['menU_UNT', '專案審核人']).value();
            }

            return !!PROJECT_AUDITOR_FOUND;
        },
        currCnyRatio() {
            if (this.project.cny == 'TWD') {
                return 1;
            }
            const cnyOptions = this.$store.getters['cny/cnyOptions'];
            for (const i in cnyOptions) {
                const cny = cnyOptions[i];
                if (cny.cny == this.project.cny) {
                    return cny.rat;
                }
            }
            return 1;
        },
        amtTWD() {
            return Math.round(this.project.amt * this.currCnyRatio);
        },
        isCreator() {
            return this.project.stF_SNO == this.$store.getters['account/userSno'];
        },
        payoutTotal() {
            return _.chain(this.project.payouts)
                .filter((o) => o.sigN_STS === 2 || o.sigN_STS === 3)
                .sumBy((o) => o.amt * o.paY_CNYRAT)
                .value();
        },
        estimateGrossProfit() {
            // 台幣
            if (this.project.cny == 'TWD') {
                return this.project.amt - this.installmentsDiscountTotal - this.project.amT_PREOUT;
            }

            // 外幣
            if (this.cnyRat) {
                return (this.project.amt - this.installmentsDiscountTotal) * this.cnyRat - this.project.amT_PREOUT;
            }
            return null;
        },
        actualGrossProfit() {
            // 台幣
            if (this.project.cny == 'TWD') {
                return Math.round(this.project.amt - this.installmentsDiscountTotal - this.payoutTotal);
            }

            // 外幣
            if (this.cnyRat) {
                return Math.round((this.project.amt - this.installmentsDiscountTotal) * this.cnyRat - this.payoutTotal);
            }
            return null;
        },
        cnyRat() {
            const cny = this.cnyList.find((c) => c.cny === this.project.cny);
            if (cny) return cny.rat;
            return null;
        },
        estimateGrossMargin() {
            if (this.estimateGrossProfit && this.project.amt) {
                // 台幣
                if (this.project.cny == 'TWD') {
                    return Math.round((this.estimateGrossProfit / (this.project.amt - this.installmentsDiscountTotal)) * 1000) / 10;
                }
                // 外幣

                return Math.round((this.estimateGrossProfit / ((this.project.amt - this.installmentsDiscountTotal) * this.cnyRat)) * 1000) / 10;
            }
            return 0;
        },
        actualGrossMargin() {
            if (this.actualGrossProfit && this.project.amt) {
                // 台幣
                if (this.project.cny == 'TWD') {
                    return Math.round((this.actualGrossProfit / (this.project.amt - this.installmentsDiscountTotal)) * 1000) / 10;
                }
                // 外幣
                return Math.round((this.actualGrossProfit / ((this.project.amt - this.installmentsDiscountTotal) * this.cnyRat)) * 1000) / 10;
            }
            return 0;
        },
        installmentsSum() {
            let sum = 0;
            if (this.project.installments) {
                this.project.installments.forEach((inst) => {
                    if (!inst.foO_DIS_CNL) {
                        // 發票作廢的分期不計入
                        sum += inst.amt;
                    }
                });
            }
            return sum;
        },
        installmentsDiscountTotal() {
            let sum = 0;
            const LIST = _.chain(this.project.installments).filter(['foO_DIS_CNL', false]).sortedUniqBy('foO_DIS_AMT').value();
            LIST.forEach((item) => {
                sum += item.foO_DIS_AMT;
            });

            return sum;
        },
        isShowDeleteBtn() {
            // 是專案PM & 分期未開
            if (!this.project.installments?.length) return false;

            if (this.project.payouts?.length) return false;
            if (this.isCreator || this.isAuth('C04')) {
                const submitedInst = this.project.installments.filter((item) => !item.Delete && item.invoiceIOO != null);
                if (submitedInst.length === 0) return true;
            }
            return false;
        },

        isContractExist() {
            return _.filter(this.project.contractFiles, ['attachmenType', 1]).length;
        },
        isQuotationExist() {
            return _.filter(this.project.contractFiles, ['attachmenType', 2]).length;
        },
        isOtherContractFileExist() {
            return _.filter(this.project.contractFiles, ['attachmenType', 3]).length;
        },
        payoutItems() {
            const summaryList = [];
            if (!this.project.payouts || this.project.payouts.length === 0) {
                return summaryList;
            }
            let total = 0;
            this.project.payouts.forEach((payout) => {
                const itemSno = payout.iteM_SNO;
                if (itemSno) {
                    let summaryItem = summaryList.find((x) => x.sno === itemSno);
                    if (!summaryItem) {
                        summaryItem = {
                            sno: itemSno,
                            name: itemSno ? payout.iteM_NAM : '（未編列項目）',
                            amt: 0,
                            count: 0,
                            percent: 0,
                        };
                        summaryList.push(summaryItem);
                    }
                    const amt = Math.round(payout.amt * payout.paY_CNYRAT);
                    summaryItem.amt += amt;
                    total += amt;
                    summaryItem.count += 1;
                }
            });
            for (let i = 0; i < summaryList.length; i += 1) {
                summaryList[i].percent = ((summaryList[i].amt / total) * 100).toFixed(1);
            }
            summaryList.sort((a, b) => b.amt - a.amt);
            return summaryList;
        },
    },
    methods: {
        async fetchAuditFlow() {
            const resp = await this.$api({
                url: '/Tool/GetAuditFlowTemplates',
                method: 'GET',
            });

            this.isAuditFlowSettingEnable = resp.data.projectAuditFlowSetting;
        },
        resetData() {
            this.vendor = null;
            this.currTab = 'installments';

            this.project = {
                sno: 0,
                mno: 0,
                vdR_TYP: '',
                voo: '',
                cnam: '',
                fnam: '',
                bsn: '',
                bsN_NO: 0,
                cty: '',
                ara: '',
                adR_CODE: '',
                adr: '',
                abd: 0,
                onf: 0,
                bilL_DAY: 0,
                soO_DAY: 0,
                crT_DAT: '',
                crT_USR: '',
                crT_UNO: 0,
                upD_DAT: '',
                upD_USR: '',
                upD_UNO: 0,
                filE_AGREE: '',
                installments: [],
                payouts: [],
                mem: '', // 修改原因
                stF_SNO: null,
                sdt: null,
                edt: null,
            };
        },
        handleInvoiceClick(sno) {
            this.invoiceDetailDialog.visible = true;
            this.invoiceDetailDialog.sno = sno;
        },
        handlePaymentClick(sno) {
            this.paymentDetailDialog.visible = true;
            this.paymentDetailDialog.sno = sno;
        },
        handleInvoiceDetailDialogClose(refresh) {
            this.$emit('update', refresh);
            if (refresh) this.loadData(this.sno);
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
        },
        handlePaymentDetailDialogClose(refresh) {
            this.$emit('update', refresh);
            if (refresh) this.loadData(this.sno);
            this.paymentDetailDialog.visible = false;
            this.paymentDetailDialog.sno = null;
        },
        handleBeforeClose() {
            this.$emit('close', false);
            this.resetData();
        },
        async loadData(sno) {
            this.isLoading = true;

            const loadingTarget = this.$refs.DetailDialog.$el.querySelector('.el-dialog');
            const loading = this.$loading({
                lock: true,
                text: '載入中',
                spinner: 'el-icon-loading',
                target: loadingTarget,
            });

            try {
                const resp = await this.$api({
                    url: `ProjectManagementPage/GetProjectDetail?Sno=${sno}`,
                    data: null,
                    method: 'GET',
                });

                const c04StaffsResp = await this.$api({
                    url: 'ProjectManagementPage/getC04Staffs',
                    method: 'GET',
                });

                await this.updateVendorDetail(resp.data.item.vdR_SNO);
                this.project = {
                    ...resp.data.item,
                    projectEmployeePermissions: [
                        ...c04StaffsResp.data.items.map((pm) => ({
                            id: `project-member-ppm-${pm.sno}`,
                            employeeSno: pm.sno,
                            employeeName: `${pm.nam} (專案總管理)`,
                            eml: pm.eml,
                            paymentRequest: true,
                            paymentBudgetChart: true,
                            invoice: true,
                            laborForm: true,
                            viewProject: true,
                            uploadDocument: true,
                            role: 'PPM',
                        })),
                        {
                            // PM（單人）
                            id: 'project-member-pm',
                            employeeSno: resp.data.item.stF_SNO,
                            employeeName: `${resp.data.item.stF_SNO_NAM}（專案經理(PM)）`,
                            eml: resp.data.item.stF_SNOEml,
                            paymentRequest: true,
                            paymentBudgetChart: true,
                            invoice: true,
                            laborForm: true,
                            viewProject: true,
                            uploadDocument: true,
                            role: 'PM',
                        },
                        {
                            // PA（單人）
                            id: 'project-member-pa',
                            employeeSno: resp.data.item.projectAuditor,
                            employeeName: `${resp.data.item.projectAuditorName}（專案經辦人）`,
                            eml: resp.data.item.projectAuditorEml,
                            paymentRequest: resp.data.item.enablePAPaymentRequest,
                            paymentBudgetChart: resp.data.item.enablePAPaymentBudgetChart,
                            invoice: resp.data.item.enablePAInvoice,
                            laborForm: resp.data.item.enablePALaborForm,
                            viewProject: resp.data.item.enablePAViewProject,
                            uploadDocument: resp.data.item.enablePAUploadDocument,
                            role: 'PA',
                        },
                        ...resp.data.item.projectEmployeePermissions,
                        {
                            // 其他所有人
                            id: 'project-member-others',
                            employeeSno: null,
                            employeeName: '其他所有人',
                            paymentRequest: resp.data.item.enableOthersPaymentRequest,
                            paymentBudgetChart: resp.data.item.enableOthersPaymentBudgetChart,
                            invoice: resp.data.item.enableOthersInvoice,
                            laborForm: resp.data.item.enableOthersLaborForm,
                            viewProject: false,
                            uploadDocument: false,
                            role: 'OTHER',
                        },
                    ],
                };

                if (resp.data.item.stF_SNO === resp.data.item.projectAuditor) {
                    const PM_INDEX = this.project.projectEmployeePermissions.findIndex((perm) => perm.id === 'project-member-pm');
                    const PA_INDEX = this.project.projectEmployeePermissions.findIndex((perm) => perm.id === 'project-member-pa');

                    if (PA_INDEX !== -1) {
                        this.project.projectEmployeePermissions.splice(PA_INDEX, 1);
                        this.project.projectEmployeePermissions[PM_INDEX].employeeName = `${resp.data.item.stF_SNO_NAM}（專案經理(PM) / 專案經辦人）`;
                    }
                }

                // 去除projectEmployeePermissions中的null項目
                if (!this.project.projectAuditor) this.project.projectEmployeePermissions = this.project.projectEmployeePermissions.filter((perm) => perm.id !== 'project-member-pa');

                console.log('Project ', this.project);

                // 外幣專案，載入匯率資訊供利潤換算
                if (this.project.cny != 'TWD') {
                    this.loadCnys();
                }
            } finally {
                this.isLoading = false;
                loading.close();
            }
        },
        loadCnys() {
            this.$api({ url: 'Tool/GetCurrencyOptions', method: 'GET' }).then((resp) => {
                this.cnyList = resp.data.options;
            });
        },
        async updateVendorDetail(vdR_SNO) {
            const resp = await this.$api({
                url: `VendorManagementPage/GetVendorInfo?SNO=${vdR_SNO}`,
                data: null,
                method: 'GET',
            });

            this.vendor = resp.data.item;
        },
        editBtnClick() {
            this.$router.push({
                name: 'project-edit',
                params: { sno: this.project.sno },
            });
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny == cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        async onDeleteProject() {
            try {
                await this.$confirm('確定要刪除該專案？', {
                    confirmButtonText: '確定刪除',
                    cancelButtonText: '取消',
                });
                await this.$api({
                    url: 'ProjectManagementPage/DeleteProjectDetail',
                    data: { sno: this.sno },
                    method: 'DELETE',
                });
                this.handleBeforeClose();
                this.$emit('update');
            } catch (e) {
                console.log(e);
            }
        },
        isFutureInvoiceDate(dat) {
            // 超過今天23:59:59的發票日期才算未來發票（電子發票時間會隨開立時間而不同）
            const TODAY = moment().endOf('day');
            return moment(dat).isAfter(TODAY);
        },
        onMoreDropdownClick(command) {
            if (command === 'duplicate') {
                this.duplicate();
            }
        },

        duplicate() {
            this.$router.push({ name: 'project-add', query: { copyfrom: this.project.sno } });
        },

        async onExportPayoutExcel() {
            const workbook = new ExcelJS.Workbook();

            // ===== Sheet 1: 明細 =====
            const detailSheet = workbook.addWorksheet('明細');
            const detailColumns = [
                { header: '#', key: 'index', width: 6 },
                { header: '請款狀態', key: 'status', width: 14 },
                { header: '請款單號', key: 'payoo', width: 14 },
                { header: '請款摘要', key: 'nam', width: 30 },
                { header: '支出項目', key: 'itemName', width: 18 },
                { header: '實際付款日', key: 'payDay', width: 14 },
                { header: '金額', key: 'amt', width: 14 },
                { header: '幣別', key: 'cny', width: 8 },
            ];
            detailSheet.columns = detailColumns;

            this.project.payouts.forEach((row, idx) => {
                const statusObj = _.find(paymentStatus, ['key', row.sigN_STS]);
                const statusText = statusObj ? statusObj.value : '';
                const payDay = (row.sigN_STS === 2 || row.sigN_STS === 3) && row.paY_DAT
                    ? dateFormater(row.paY_DAT, 'YYYY-MM-dd')
                    : '---';

                detailSheet.addRow({
                    index: idx + 1,
                    status: statusText,
                    payoo: row.payoo || '',
                    nam: row.nam || '',
                    itemName: row.iteM_NAM || '',
                    payDay,
                    amt: row.amt,
                    cny: row.cny || '',
                });
            });

            // 加總列（僅計算待確認付款 + 完成）
            if (this.payoutTotal > 0) {
                const totalRow = detailSheet.addRow({
                    index: '',
                    status: '',
                    payoo: '',
                    nam: '',
                    itemName: '',
                    payDay: '',
                    amt: this.payoutTotal,
                    cny: 'TWD',
                });
                const labelCell = totalRow.getCell('status');
                labelCell.value = '專案總支出';
                labelCell.font = { bold: true };
                totalRow.getCell('amt').font = { bold: true };
            }

            // 標題列樣式
            const detailHeaderRow = detailSheet.getRow(1);
            detailHeaderRow.eachCell((cell) => {
                cell.font = { bold: true, size: 10 };
                cell.alignment = { vertical: 'middle' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2EFDA' } };
            });
            detailSheet.views = [{ state: 'frozen', ySplit: 1 }];

            // 金額欄數字格式
            detailSheet.getColumn('amt').numFmt = '#,##0';

            // ===== Sheet 2: 統計 =====
            const summarySheet = workbook.addWorksheet('統計');
            const summaryColumns = [
                { header: '#', key: 'index', width: 6 },
                { header: '支出項目', key: 'name', width: 24 },
                { header: '數量', key: 'count', width: 10 },
                { header: '金額', key: 'amt', width: 14 },
                { header: '幣別', key: 'cny', width: 8 },
                { header: '%', key: 'percent', width: 10 },
            ];
            summarySheet.columns = summaryColumns;

            this.payoutItems.forEach((item, idx) => {
                summarySheet.addRow({
                    index: idx + 1,
                    name: item.name || '',
                    count: item.count,
                    amt: item.amt,
                    cny: 'TWD',
                    percent: `${item.percent} %`,
                });
            });

            // 合計列
            if (this.payoutItems.length > 0) {
                const totalCount = this.payoutItems.reduce((acc, o) => acc + o.count, 0);
                const totalAmt = this.payoutItems.reduce((acc, o) => acc + o.amt, 0);
                const summaryTotalRow = summarySheet.addRow({
                    index: '',
                    name: '合計',
                    count: totalCount,
                    amt: totalAmt,
                    cny: 'TWD',
                    percent: '100 %',
                });
                summaryTotalRow.eachCell((cell) => {
                    cell.font = { bold: true };
                });
            }

            // 標題列樣式
            const summaryHeaderRow = summarySheet.getRow(1);
            summaryHeaderRow.eachCell((cell) => {
                cell.font = { bold: true, size: 10 };
                cell.alignment = { vertical: 'middle' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDAE8FC' } };
            });
            summarySheet.views = [{ state: 'frozen', ySplit: 1 }];

            // 金額欄數字格式
            summarySheet.getColumn('amt').numFmt = '#,##0';

            // 下載
            const today = moment().format('YYYY-MM-DD');
            const fileName = `${this.project.nam}-支出列表-${today}.xlsx`;
            this.downloadExcel(workbook, fileName);
        },

        async downloadExcel(workbook, fileName) {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.project-detail-dialog {
    &.ah-detail-dialog > .el-dialog {
        max-width: 1100px;
    }

    .total-amount {
        display: table;
        text-align: right;
        margin: 10px 0 10px auto;
        font-weight: bold;
        font-size: 11pt;

        .label {
            display: table-cell;
            padding-right: 20px;
        }

        .value {
            display: table-cell;
            width: 50px;
            padding-right: 20px;
        }

        .cny {
            display: table-cell;
            width: 90px;
            text-align: left;
        }
    }

    .chart-set {
        position: relative;

        .percent {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            line-height: 200px;
            text-align: center;
            font-size: 17pt;
            font-weight: bold;
            color: #888;
        }
    }

    .other-buyer {
        font-size: 9pt;
        color: #888;
        line-height: 1;
    }

    .discount-block {
        display: inline-block;
        background-color: #ffe8e8;
        color: #ff2c2c;
        border-radius: 5px;
        padding: 0 8px;
        width: fit-content;
        font-weight: bold;
        font-size: 9pt;
        margin-left: 6px;
    }
    .discount-amt {
        color: #ff2c2c;
        font-size: 9pt;
    }

    .foo-dat {
        font-size: 9pt;
        color: #888;
        & .is-future {
            color: green;
        }
    }
    .tab-content-header {
        display: flex;
        justify-content: space-between;
    }
    .payout-item-label {
        display: inline-block;
        padding: 0px 6px;
        border-radius: 5px;
        font-size: 9pt;
        background-color: #eee;
        color: #666;
        cursor: default;
    }
    .el-table td,
    th {
        font-size: 10pt;
    }

    .ah-basic-data-table {
        th {
            white-space: nowrap;
            word-break: keep-all;
        }
    }
}
</style>
